module.exports = __webpack_public_path__ + "static/media/nepzaServices.6b8a45c3.svg";